<script>
import dateMixin from "@/mixins/dateMixin";
import moment from "@/utils/moment";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [dateMixin],
  data() {
    return {
      minDate: moment().toISOString(),
      menu: false
    };
  },
  computed: {
    ...mapState("sendNotifications", ["dates"])
  },
  methods: {
    ...mapActions("sendNotifications", ["setDates"])
  }
};
</script>

<template>
  <v-menu
    top
    offset-y
    v-model="menu"
    origin="left bottom"
    transition="scale-transition"
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-combobox
        dense
        chips
        filled
        readonly
        multiple
        required
        clearable
        small-chips
        name="dates"
        prepend-inner-icon="mdi-calendar-multiselect"
        label="Selecione o(s) dia(s) que a notificação será enviada"
        v-on="on"
        v-validate="'required'"
        data-vv-as="data"
        :value="dates"
        :error="errors.has('dates')"
        :error-messages="errors.first('dates')"
        @input="setDates"
      >
        <template v-slot:selection="{ attrs, item, parent }">
          <v-chip
            v-bind="attrs"
            close
            small
            @click:close="parent.selectItem(item)"
            >{{ item | getDate }}</v-chip
          >
        </template>
      </v-combobox>
    </template>

    <v-date-picker
      column
      multiple
      scrollable
      color="primary"
      :min="minDate"
      :value="dates"
      @input="setDates"
    >
      <v-layout column>
        <v-divider></v-divider>

        <v-layout class="mt-2">
          <v-spacer></v-spacer>
          <v-btn rounded color="primary" @click="menu = false">ok</v-btn>
        </v-layout>
      </v-layout>
    </v-date-picker>
  </v-menu>
</template>



// WEBPACK FOOTER //
// src/components/Notifications/Send/Steps/Scheduling/MultipleDatePicker.vue